import {createSlice} from '@reduxjs/toolkit'

const rfqSlice = createSlice({
    name: 'rfqSlice',
    initialState: {
        editableLineData: [],
        selectedRFQs: [],
        selectedRfqLine: [],
        selectedRFQLines: [],
        selectedRFQLineRequests: [],
        selectedRequests: [],
        differenceRequests: [],
        deletedDetailIds: [],
        deletedRequestDetailIds: [],
        rfqDataForCreate: {},
        ruomDialog: null,
        filterData: {},
    },
    reducers: {
        updateEditableLineData: (state, action) => {
            state.editableLineData = action.payload
        },
        updateSelectedRFQsData: (state, action) => {
            state.selectedRFQs = action.payload
        },
        updateSelectedRFQLineData: (state, action) => {
            state.selectedRfqLine = action.payload
        },
        updateSelectedRFQLinesData: (state, action) => {
            state.selectedRFQLines = action.payload
        },
        updateSelectedRFQLineRequestsData: (state, action) => {
            state.selectedRFQLineRequests = action.payload
        },
        updateSelectedRequestsData: (state, action) => {
            state.selectedRequests = action.payload
        },
        updateDifferenceRequestsData: (state, action) => {
            state.differenceRequests = action.payload
        },
        updateDeletedDetailIds: (state, action) => {
            state.deletedDetailIds = action.payload
        },
        updateDeletedRequestDetailIds: (state, action) => {
            state.deletedRequestDetailIds = action.payload
        },
        updateRuomDialog: (state, action) => {
            state.ruomDialog = action.payload
        },
        updateRfqDataForCreate: (state, action) => {
            state.rfqDataForCreate = action.payload
        },
        updateFilterData: (state, action) => {
            state.filterData = action.payload
        }
    },
})

export const {
    updateEditableLineData,
    updateSelectedRFQsData,
    updateSelectedRFQLinesData,
    updateSelectedRFQLineRequestsData,
    updateSelectedRFQLineData,
    updateSelectedRequestsData,
    updateDifferenceRequestsData,
    updateRuomDialog,
    updateDeletedDetailIds,
    updateDeletedRequestDetailIds,
    updateFilterData,
    updateRfqDataForCreate
} = rfqSlice.actions

export const rfqDataReducer = rfqSlice.reducer